module.exports = __webpack_public_path__ + "static/media/codingbuddy_forloop.78217e70.gif";